/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedemptionUrlItem
 */
export interface RedemptionUrlItem {
    /**
     * Index of the order item to update
     * @type {number}
     * @memberof RedemptionUrlItem
     */
    index: number;
    /**
     * Index within the quantity (0 for first card, 1 for second, etc.)
     * @type {number}
     * @memberof RedemptionUrlItem
     */
    urlIndex: number;
    /**
     * The redemption URL for the item
     * @type {string}
     * @memberof RedemptionUrlItem
     */
    redemptionUrl: string;
}

/**
 * Check if a given object implements the RedemptionUrlItem interface.
 */
export function instanceOfRedemptionUrlItem(value: object): value is RedemptionUrlItem {
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('urlIndex' in value) || value['urlIndex'] === undefined) return false;
    if (!('redemptionUrl' in value) || value['redemptionUrl'] === undefined) return false;
    return true;
}

export function RedemptionUrlItemFromJSON(json: any): RedemptionUrlItem {
    return RedemptionUrlItemFromJSONTyped(json, false);
}

export function RedemptionUrlItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedemptionUrlItem {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'urlIndex': json['urlIndex'],
        'redemptionUrl': json['redemptionUrl'],
    };
}

export function RedemptionUrlItemToJSON(json: any): RedemptionUrlItem {
    return RedemptionUrlItemToJSONTyped(json, false);
}

export function RedemptionUrlItemToJSONTyped(value?: RedemptionUrlItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'urlIndex': value['urlIndex'],
        'redemptionUrl': value['redemptionUrl'],
    };
}

